import { useQueryExpense } from '../../models/useQueryExpense'

interface IUseExpenseCostSummaryPresenterProps {
  uuid: string
}

export const useExpenseCostSummaryPresenter = ({
  uuid,
}: IUseExpenseCostSummaryPresenterProps) => {
  const { expense, isLoading } = useQueryExpense(uuid)

  return {
    data: {
      subtotal: expense?.subtotal ?? 0,
      taxTotal: expense?.taxTotal ?? 0,
      totalAmount: expense?.totalAmount ?? 0,
      reimbursableAmount: expense?.reimbursableAmount ?? 0,
      currencyName: expense?.currency.name,
    },
    states: {
      isLoading,
    },
  }
}
